import { FeaturesService } from 'client/services';
import PropTypes from 'prop-types';
import styles from './LinkedFiles.module.scss';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { isInternalFile } from 'client/utils/helpers/LinkedFiles/LinkedFilesUtils';

const LinkedFiles = ({ linkedFiles, assetType, assetTypeId }) => {
    const [fileDownloadFault, setFileDownloadFault] = useState(false);

    const handleOpen = async (linkedFileId, artefactTable, artefactId) => {
        const imageData = await FeaturesService.downloadLinkedFile(linkedFileId, artefactTable, artefactId);
        if (imageData) {
            const objectURL = URL.createObjectURL(imageData);
            window.open(objectURL, '_blank', 'noopener, noreferrer');
        } else {
            setFileDownloadFault(true);
        }
    };

    return linkedFiles?.map(linkedFile => {
        if (isInternalFile(linkedFile)) {
            return <div key={linkedFile?.systemId}>
                <p>
                    <a onClick={() => handleOpen(linkedFile?.systemId, assetType, assetTypeId)}
                        className={['govuk-link', 'govuk-body', styles.linkedFileLinks].join(' ')} target="_blank"
                        rel="noopener noreferrer nofollow">{linkedFile?.name}</a>
                </p>

                {fileDownloadFault &&
                    <div className="govuk-error-message">
                        <FormattedMessage id='supplementaryDataTab.linkedFile.error.text' />
                    </div>
                }
            </div>;
        } else {
            return <div key={linkedFile?.systemId}>
                <a href={linkedFile?.fullpath}
                    className={['govuk-link', 'govuk-body'].join(' ')} target="_blank"
                    rel="noopener noreferrer nofollow">{linkedFile?.name}</a>
            </div>;
        }
    });
};

LinkedFiles.prototypes = {
    linkedFiles: PropTypes.array,
    assetType: PropTypes.string.isRequired,
    assetTypeId: PropTypes.string.isRequired
};

export default LinkedFiles;
